module.exports = __webpack_public_path__ + "static/media/purple.5a0494f8.png";